module.exports = __webpack_public_path__ + "static/media/enhanced-grain-jarrah.110353ee.png";